module.exports = __webpack_public_path__ + "img/blue_070.5ad1e16b.png";